module.exports = __webpack_public_path__ + "img/1Menu.ab617652.png";